import { render, staticRenderFns } from "./IKFiltroCliente.vue?vue&type=template&id=82836d30&"
import script from "./IKFiltroCliente.vue?vue&type=script&lang=js&"
export * from "./IKFiltroCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports